import PropTypes from "prop-types";

import { ArrowRight } from "../../Assets/Icons";

export default function CardButton({ className = "", title, description, Icon, onClick }) {
  return (
    <button className={`card-button ${className}`} onClick={onClick}>
      <Icon className="icon" />
      <div className="card-content">
        <span className="title">{title}</span>
        {!!description && <span className="description">{description}</span>}
      </div>
      <div className="spacer" />
      <ArrowRight className="chevron" />
    </button>
  );
}

CardButton.prototype = {
  title: PropTypes.string.isRequired,
  Icon: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
};
